export const data = [
  {
    id: 1,
    name: "Ahmad Shah",
    number: "10 1111 2222",
    order: "1",
    block: "Block",
    active: "Active", 
  },
  {
    id: 2,
    name: "Ahmad Shah",
    number: "10 1111 2222",
    order: "1",
    block: "Block",
    active: "Active",
  },
  {
    id: 3,
    name: "Ahmad Shah",
    number: "10 1111 2222",
    order: "1",
    block: "Block",
    active: "Active",
  },
  {
    id: 4,
    name: "Ahmad Shah",
    number: "10 1111 2222",
    order: "1",
    block: "Block",
    active: "Active",
  },
  {
    id: 5,
    name: "Ahmad Shah",
    number: "10 1111 2222",
    order: "1",
    block: "Block",
    active: "Active",
  },
  {
    id: 6,
    name: "Ahmad Shah",
    number: "10 1111 2222",
    order: "1",
    block: "Block",
    active: "Active",
  },
  {
    id: 7,
    name: "Ahmad Shah",
    number: "10 1111 2222",
    order: "1",
    block: "Block",
    active: "Active",
  },
  {
    id: 8,
    name: "Ahmad Shah",
    number: "10 1111 2222",
    order: "1",
    block: "Block",
    active: "Active",
  },
  {
    id: 9,
    name: "Ahmad Shah",
    number: "10 1111 2222",
    order: "1",
    block: "Block",
    active: "Active",
  },
  {
    id: 10,
    name: "Ahmad Shah",
    number: "10 1111 2222",
    order: "1",
    block: "Block",
    active: "Active",
  },
]; 
